import { hideNotification } from 'ducks/notification';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ErrorNotification from './ErrorNotification';
import WarningNotification from './WarningNotification';

const NOTIFICATION_COMPONENTS = {
  'ERROR': ErrorNotification,
  'WARNING': WarningNotification
};

const RootNotification = ({notificationType, notificationProps, hideNotification}) => {
  if (!notificationType) {
    return null;
  }

  const SpecificNotification = NOTIFICATION_COMPONENTS[notificationType];
  return <SpecificNotification hideNotification={hideNotification} {...notificationProps} />;
};

const mapDispatchToProps = dispatch => bindActionCreators({
  hideNotification: () => hideNotification(),
}, dispatch);

export default connect(
  state => state.notification,
  mapDispatchToProps
)(RootNotification);


// WEBPACK FOOTER //
// ./src/components/notification/RootNotification.jsx